<h4 class="mb-0 f-16 default-color" data-qa-id="notif-title">{{ title }}</h4>
<a *ngIf="showClear" (click)="clear.emit()" class="color-primary" data-qa-id="notif-clear"
  i18n="@@notificationHeader.ClearAll"> Clear all </a>